<template>
    <b-row>
        <!-- <b-form> -->
          <b-col cols="12">
            <b-button id="advanced-options-btn" @click="toggleConditionsModal" variant="warning">
              Conditions
            </b-button>
            <br>
            <div v-if="formButton.conditions">
            <div v-if="formButton.conditions.visibility.length">
              <strong>Visible If (with <span>{{formButton.conditions.visibility_operand}}</span> logic)</strong>
              <ul>
                <li v-for="cond in formButton.conditions.visibility">{{ cond.actor }} {{ cond.cond }} {{ cond.value }}</li>
              </ul>
            </div>
            <div v-else><strong>Always Visible</strong></div>
          </div>
          </b-col>
          <b-modal ok-only centered size="xl" title="Conditions for the Form Button" ref="ConditionsForm">
            <b-form>
              <conditioning-fields />
            </b-form>
            <div slot="footer" class="dialog-footer">
              <b-button variant="primary" @click.prevent="toggleConditionsModal">Confirm</b-button>
            </div>
          </b-modal>

        <!-- </b-form> -->

    </b-row>
</template>

<script>

import ConditioningFields from '../components/bs/ConditioningFields'
export default {
  name: 'ButtonSettings',
  store: ['formButton', 'editingButton'],
  components: {
    ConditioningFields
  },
  methods: {
    toggleConditionsModal() {
      this.editingButton = true
      this.$refs['ConditionsForm'].toggle('#conditions-btn')
    },
  }
}
</script>
